/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import CheckRestrictions from './containers/check-restrictions';
import StudyRestrictions from './containers/study-restrictions';

import Forbidden from './components/errors/forbidden';
import UnexpectedError from './components/errors/unexpected-error';
import NotFound from './components/errors/not-found';

const Routes = (): ReactElement => (
  <Switch>
    <Route path="/study" exact component={CheckRestrictions} />
    <Route path="/study-restrictions" component={StudyRestrictions} />
    <Route path="/forbidden" component={Forbidden} />
    <Route path="/unexpected-error" component={UnexpectedError} />
    <Route path="/not-found" component={NotFound} />
    <Redirect from="*" to="/not-found" />
  </Switch>
);

export default Routes;
